"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DropdownMenu = _interopRequireDefault(require("rc-select/lib/DropdownMenu"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class AdvancedDropdownMenu extends _DropdownMenu.default {
  constructor(props) {
    super(props);
    this.oldRenderMenu = this.renderMenu;
    this.renderMenu = this.newRenderMenu;
  }
  newRenderMenu() {
    const renderMenu = this.oldRenderMenu();
    const {
      wrapper = innerMenu => innerMenu
    } = this.props;
    return wrapper(renderMenu);
  }
}
exports.default = AdvancedDropdownMenu;